module.exports = __webpack_public_path__ + "img/medication-quantity.ef25e002.svg";